import { getDisplayName, getTooltip } from "models/Environment";

export const SbbHeaderEnvironment: React.FC = () => {
  return (
    <div
      className="sbb-header-environment global-tooltip-trigger d-none d-sm-block"
      id="environment"
      data-bs-title={getTooltip()}
    >
      {getDisplayName()}
    </div>
  );
};
